import React, { useState } from "react";
import "./TourFilter.css";
import countries from "../data/countries.json";

const TourFilter = ({ onFilterChange, filters }) => {

    const handleInputChange = (field, value) => {
        onFilterChange({
            ...filters,
            [field]: value
        });
    };

    const clearFilters = () => {
        onFilterChange({
            name: "",
            country: "",
            createdBy: ""
        });
    };

    const hasActiveFilters = () => {
        return Object.values(filters).some(value => value !== "");
    };

    return (
        <div className="tour-filter-container">
            <div className="filter-header">
                <h5 className="filter-title">
                    <i className="fa fa-filter"></i>
                    Filter Tours
                </h5>
                {hasActiveFilters() && (
                    <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={clearFilters}
                    >
                        Clear All
                    </button>
                )}
            </div>

            <div className="filter-content">
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Tour Name</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by tour name..."
                                value={filters.name}
                                onChange={(e) => handleInputChange("name", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Country</label>
                            <select
                                className="form-control"
                                value={filters.country}
                                onChange={(e) => handleInputChange("country", e.target.value)}
                            >
                                <option value="">All Countries</option>
                                {countries.map((c) => (
                                    <option key={c.name} value={c.name}>
                                        {c.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Created By</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Filter by creator..."
                                value={filters.createdBy}
                                onChange={(e) => handleInputChange("createdBy", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TourFilter; 